import { OverlayRef } from '@angular/cdk/overlay';
import { Component, Inject, OnInit } from '@angular/core';
import { OVERLAY_DATA, OVERLAY_REF } from 'src/app/interfaces/mini-guide';
import { MiniGuidanceService } from 'src/app/services/common/mini-guidance.service';

@Component({
  selector: 'app-mini-guide',
  templateUrl: './mini-guide.component.html',
  styleUrls: ['./mini-guide.component.css']
})
export class MiniGuideComponent implements OnInit {

  guideList: string = '';
  title: string = '';

  guide: any;

  constructor(
    @Inject(OVERLAY_REF) private overlayRef: OverlayRef,
    @Inject(OVERLAY_DATA) public data: any,
    private miniGuideService: MiniGuidanceService
  ) { }

  ngOnInit() {
    this.getData();

    this.miniGuideService.onForceClose.subscribe(() => {
      this.onClose();
    })
  }

  getData()
  {
    this.guide = this.miniGuideService.getGuides(this.data.id);
    console.log(this.guide);
    this.guideList = this.guide.guideList;
    this.title = this.guide.title;
  }


  onNextGuide()
  {
    this.overlayRef.dispose();
    this.miniGuideService.closeGuide(true);
  }

  onPreviusGuide()
  {
    this.overlayRef.dispose();
    this.miniGuideService.closeGuide(false);
  }

  onClose()
  {
    this.overlayRef.dispose();
    this.miniGuideService.closeGuide(true);
  }

}
